import Swal from 'sweetalert2';

// CSS animations for success checkmark (defined once outside function)
const successCheckmarkStyles = `
  @keyframes scaleIn {
    0% { transform: scale(0); opacity: 0; }
    80% { transform: scale(1.1); opacity: 1; }
    100% { transform: scale(1); opacity: 1; }
  }
  .animate-scale-in {
    animation: scaleIn 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;
  }
  .checkmark-circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
  }
  .checkmark-check {
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.6s forwards;
  }
  @keyframes stroke {
    100% { stroke-dashoffset: 0; }
  }
`;

// Helper function to set toast container styles
const setToastContainerStyles = (popup) => {
  const container = popup.parentElement;
  if (container) {
    container.style.marginTop = '80px';
    container.style.marginRight = '16px';
  }
};

export async function sendEmail( email, subject, pdfBlob, text, pdfName) {
  try {
    // Show processing toast immediately
    const processingToast = Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      width: '360px',
      padding: '1rem',
      backdrop: false,
      html: `
        <div class="flex items-start gap-3">
          <img src="/Images/Loading_HSC.gif" alt="Processing" class="h-8 w-8" />
          <div>
            <h3 class="text-sm font-medium text-gray-900">Processing Request</h3>
            <p class="text-xs text-gray-500">Generating PDF document...</p>
          </div>
        </div>
      `,
      customClass: {
        popup: '!rounded-xl !p-3 !bg-white !border !border-gray-200 !shadow-lg',
        container: 'custom-toast-top-margin',
      },
      didOpen: () => setToastContainerStyles(Swal.getPopup())
    });

    // Update toast to sending status
    await Swal.update({
      html: `
        <div class="flex items-start gap-3">
          <img src="/Images/Loading_HSC.gif" alt="Sending" class="h-8 w-8" />
          <div>
            <h3 class="text-sm font-medium text-gray-900">Sending Email</h3>
            <p class="text-xs text-gray-500">Delivering to ${email}</p>
          </div>
        </div>
      `
    });

    const formData = new FormData();
    if (pdfBlob) {
      formData.append('pdf', pdfBlob, pdfName);
    }
    formData.append('to', email);
    formData.append('subject', subject);
    formData.append('text', text);

    // Send email
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/send-email`, {
      method: 'POST',
      body: formData
    });

    if (!response.ok) throw new Error('Email delivery failed');

    // Show success toast
    await Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      width: '360px',
      padding: '1rem',
      html: `
        <div class="flex items-center gap-3">
          <div class="h-8 w-8">
            <svg class="checkmark animate-scale-in" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
              <circle class="checkmark-circle" cx="26" cy="26" r="25" fill="none" stroke="#16a34a" stroke-width="2"/>
              <path class="checkmark-check" fill="none" stroke="#16a34a" stroke-width="4" stroke-linecap="round" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
            </svg>
          </div>
          <div>
            <h3 class="text-sm font-medium text-gray-900">Email Sent</h3>
            <p class="text-xs text-gray-500">Delivered to ${email}</p>
          </div>
        </div>
      `,
      timer: 2000,
      customClass: {
        popup: '!rounded-xl !p-3 !bg-green-50 !border !border-green-100',
        container: 'custom-toast-top-margin',
      },
      willOpen: () => {
        setToastContainerStyles(Swal.getPopup());
        // Add CSS animations if not already present
        if (!document.getElementById('success-checkmark-styles')) {
          const style = document.createElement('style');
          style.id = 'success-checkmark-styles';
          style.textContent = successCheckmarkStyles;
          document.head.appendChild(style);
        }
      }
    });

  } catch (error) {
    await Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3500,
      timerProgressBar: true,
      width: '340px',
      padding: '0.75rem',
      html: `
        <div class="flex items-start gap-3">
          <img src="/Images/Error_Cross.gif" alt="Error" class="h-6 w-6 mt-0.5" />
          <div>
            <h3 class="text-sm font-medium text-gray-800">Email not sent</h3>
            <p class="text-xs text-gray-500">We couldn’t deliver this email right now. Please try again later.</p>
          </div>
        </div>
      `,
      customClass: {
        popup: '!rounded-lg !p-3 !bg-white !border !border-gray-200 !shadow',
        container: 'custom-toast-top-margin',
      }
    });
  
    // Optionally log for diagnostics
    console.error('Email sending failed:', error);
  
    throw error;
  }
  
}